import { combineReducers } from "redux";

import { IRootStateProps } from "types/reducers";

import account from "store/reducers/account";
import filters from "store/reducers/filters";
import scheduling from "store/reducers/scheduling";
import settings from "store/reducers/settings";
import templates from "store/reducers/templates";
import user from "store/reducers/user";
import context from "store/reducers/context";

const reducers = combineReducers<IRootStateProps>({
  account,
  filters,
  scheduling,
  settings,
  templates,
  user,
  context,
});

export default reducers;
